module.exports = __webpack_public_path__ + "img/gallery3.1ed701ea.webp";